import { Component, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { fetchAndActivate, getRemoteConfig, getString, getBoolean } from 'firebase/remote-config';
import { TranslateService } from '@ngx-translate/core';
import { ApiService, ErrorResponse } from './services/api.service';
import { Router, NavigationStart } from '@angular/router';
import { fromEvent, map, merge, of, Subscription } from 'rxjs';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  title: WritableSignal<string> = signal('domusign-web');
  networkStatus: WritableSignal<boolean> = signal(false);
  isServerOk: WritableSignal<boolean> = signal(true);
  refreshing: WritableSignal<boolean> = signal(false);
  maintenance: WritableSignal<boolean> = signal(false);
  motd: WritableSignal<boolean> = signal(false);
  lang: WritableSignal<string> = signal('fr');
  maintenance_msg: WritableSignal<any> = signal(undefined);
  motd_msg: WritableSignal<any> = signal(undefined);

  remoteConfig: any = getRemoteConfig();

  private networkStatusSubscription: Subscription = Subscription.EMPTY;

  constructor(translate: TranslateService, private apiService: ApiService, private router: Router) {

    router.events.subscribe((val: any): void => {
      if (val instanceof NavigationStart) {
        this.checkConnection();
        this.getRemoteConfig();
      }
    });

    let userLang: string = navigator.language;
    translate.addLangs(environment.langs);
    translate.setDefaultLang(environment.langs[0]);

    if (userLang && userLang.length >= 2) {
      userLang = userLang.slice(0, 2);
    }

    if (localStorage.getItem('language')) {
      userLang = localStorage.getItem('language');
    }

    if (environment.langs.includes(userLang)) {
      this.lang.set(userLang);
      translate.use(userLang);
      localStorage.setItem('language', userLang);
    }
    else {
      this.lang.set('fr');
      translate.use('fr');
      localStorage.setItem('language', 'fr');
    }
  }

  ngOnInit(): void {
    this.checkNetworkStatus();

    this.apiService.post('', {}, (_: any): void => {
      this.isServerOk.set(true);
    }, (_: ErrorResponse): void => {
      this.isServerOk.set(false);
    });
  }

  ngOnDestroy(): void {
    this.networkStatusSubscription?.unsubscribe();
  }

  checkNetworkStatus(): void {
    this.networkStatus.set(navigator.onLine);

    this.networkStatusSubscription = merge(of(null), fromEvent(window, 'online'), fromEvent(window, 'offline'))
      .pipe(map((): boolean => navigator.onLine))
      .subscribe((status: boolean): void => {
        this.networkStatus.set(status);
      });
  }

  checkConnection(): void {
    this.apiService.post('', {}, (_: any): void => {
      this.isServerOk.set(true);
      this.refreshing.set(false);
    }, (_: ErrorResponse): void => {
      this.isServerOk.set(false);
      this.refreshing.set(false);
    });
  }

  getRemoteConfig(): void {
    this.remoteConfig.settings.minimumFetchIntervalMillis = 30000;

    fetchAndActivate(this.remoteConfig)
      .then((): void => {
        this.maintenance.set(getBoolean(this.remoteConfig, 'maintenance'));
        this.maintenance_msg.set(JSON.parse(getString(this.remoteConfig, 'maintenance_msg')));

        this.motd.set(getBoolean(this.remoteConfig, 'motd'));
        this.motd_msg.set(JSON.parse(getString(this.remoteConfig, 'motd_msg')));
      })
      .catch((_: any): void => {

      });
  }

  handleMotdButton(): void {
    if (this.motd_msg().btn_link) {
      window.open(this.motd_msg().btn_link, '_blank');
    }
  }

  refresh(): void {
    this.refreshing.set(true);
    this.checkConnection();
  }

}
